burgerMenu = {
    init() {
        const hamburger = document.querySelector(".hamburger");
        hamburger.addEventListener("click", (e) => {
            e.currentTarget.classList.toggle("is-active");
        });

        const hamburgerButton = document.getElementById("hamburger");
        console.log(hamburgerButton);
        hamburgerButton.addEventListener('click', () => {
            document.querySelector(".header_mobile--nav").classList.toggle('active');
            document.body.classList.toggle('menu-active');
        })
    }
}
export let burgerMenu;